export default __webpack_public_path__ + "static/media/15.57461631.jpg";